import { AxiosError } from 'axios'
import { appFetch } from '../store/reducer/app'
import { store } from '../store'
import { toast } from 'react-toastify'

export const showErrorMessage = (details: any, title?: string) => {
  const extractMessages = (data: any): string[] => {
    if (typeof data === 'string') {
      return [data]
    } else if (Array.isArray(data)) {
      return data.map((item) => (typeof item === 'string' ? item : JSON.stringify(item)))
    } else if (data && typeof data === 'object') {
      if (data['json'] || data['query']) {
        const jsonMessages = data['json'] ? [JSON.stringify(data['json'])] : []
        const queryMessages = data['query'] ? [JSON.stringify(data['query'])] : []
        return [...jsonMessages, ...queryMessages]
      } else {
        return [JSON.stringify(data)]
      }
    } else {
      return [JSON.stringify(data)]
    }
  }

  const errorMessages = details ? extractMessages(details) : title ? [title] : ['Unknown error']

  if (errorMessages.length > 0) {
    toast(errorMessages.join('\n'), {
      type: 'error',
      position: 'top-center',
      style: {
        wordBreak: 'break-word',
        whiteSpace: 'pre-line',
        maxWidth: 400,
      },
    })
  }
}

export const customErrorResponse = async (error: AxiosError): Promise<any> => {
  const { response }: AxiosError = { ...error }
  if (response && response.data) {
    const errorMessage = (response.data as { 'Error Message'?: { details?: any; error_code?: string; title?: string } | string })[
      'Error Message'
    ]
    if (errorMessage) {
      if (typeof errorMessage === 'string') {
        toast(errorMessage, {
          type: 'error',
          position: 'top-center',
          style: {
            wordBreak: 'break-word',
            whiteSpace: 'pre-line',
            maxWidth: 400,
          },
        })
      } else {
        const { details, error_code, title } = errorMessage
        const { status } = response
        if (status === 400 || status === 401 || status === 403 || status === 422 || status === 500) {
          if (error_code === 'ER-401-2') {
            await store.dispatch(appFetch())
          } else {
            showErrorMessage(details, title)
          }
        } else {
          toast(details ? JSON.stringify(details) : title || 'Unknown error', {
            type: 'error',
            position: 'top-center',
            style: {
              wordBreak: 'break-word',
              whiteSpace: 'pre-line',
              maxWidth: 400,
            },
          })
        }
      }
    }
  }
  console.error({ ...error })
  return Promise.reject({ ...error })
}
